export default "__VITE_ASSET__BDeQLvaj__"